/* eslint-disable import/prefer-default-export */
import {useRouteMatch} from 'react-router';

export const useStoreSlug = (): string => {
  const match = useRouteMatch<{urlSlug?: string}>([
    '/signals',
    '/:urlSlug/manage',
    '/:urlSlug/products',
    '/:urlSlug/orderSummary',
    '/:urlSlug/orderConfirmation',
    '/:urlSlug'
  ]);
  return match?.params.urlSlug;
};
